/* Essenza · comportamento dos blocos da estrutura de referência */
(() => {
  if (window.__mvStore) return;
  window.__mvStore = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(key) {
      try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
    },
    set(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* sem armazenamento */ }
    },
  };

  /* ---------- Mini carrossel de depoimentos ---------- */
  class MvxCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mvx-track]');
      if (!this.track) return;
      this.slides = this.track.querySelectorAll('[data-mvx-slide]');
      this.index = 0;
      this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
      const nav = this.querySelector('.mvx-tst__nav');
      if (this.slides.length < 2 && nav) nav.hidden = true;
      this.querySelector('[data-mvx-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-mvx-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.t);
        this.t = setTimeout(() => { this.index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)); }, 80);
      }, { passive: true });
      ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    go(i, user) {
      const n = this.slides.length;
      if (!n) return;
      this.index = (i + n) % n;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      if (user) { this.stop(); this.start(); }
    }
    start() {
      if (!this.delay || reduceMotion || this.slides.length < 2 || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
  }
  if (!customElements.get('mvx-carousel')) customElements.define('mvx-carousel', MvxCarousel);

  /* ---------- Avaliações da loja ---------- */
  const VOTES_KEY = 'mvr-votes';

  function paintVotes(scope) {
    const votes = store.get(VOTES_KEY) || {};
    scope.querySelectorAll('[data-mvr-helpful]').forEach((box) => {
      const card = box.closest('[data-mvr-card]') || box.closest('[data-mvr-for]');
      const id = card?.dataset.mvrId || card?.dataset.mvrFor;
      const mine = votes[id];
      box.querySelectorAll('[data-mvr-vote]').forEach((btn) => {
        const type = btn.dataset.mvrVote;
        const base = parseInt(btn.dataset.base, 10) || 0;
        const on = mine === type;
        btn.setAttribute('aria-pressed', String(on));
        const n = btn.querySelector('[data-mvr-n]');
        if (n) n.textContent = String(base + (on ? 1 : 0));
      });
    });
  }

  function vote(btn) {
    const box = btn.closest('[data-mvr-helpful]');
    const holder = box.closest('[data-mvr-card]') || box.closest('[data-mvr-for]');
    const id = holder?.dataset.mvrId || holder?.dataset.mvrFor;
    if (!id) return;
    const votes = store.get(VOTES_KEY) || {};
    votes[id] = votes[id] === btn.dataset.mvrVote ? null : btn.dataset.mvrVote;
    if (!votes[id]) delete votes[id];
    store.set(VOTES_KEY, votes);
    document.querySelectorAll('[data-mvr]').forEach(paintVotes);
  }

  function initReviews(root) {
    if (root.__mvrReady) return;
    root.__mvrReady = true;
    paintVotes(root);

    const modal = root.querySelector('[data-mvr-modal]');
    const slot = modal?.querySelector('[data-mvr-modal-slot]');
    const helpSlot = modal?.querySelector('[data-mvr-modal-helpful]');
    let current = null;

    const visibleCards = () => [...root.querySelectorAll('[data-mvr-card]:not(.is-hidden)')];

    function open(card) {
      if (!modal || !slot) return;
      current = card;
      const tpl = card.querySelector('template[data-mvr-modal-content]');
      slot.innerHTML = tpl ? tpl.innerHTML : '';
      slot.scrollTop = 0;
      const help = card.querySelector('[data-mvr-helpful]');
      helpSlot.innerHTML = '';
      if (help) {
        const wrap = document.createElement('div');
        wrap.dataset.mvrFor = card.dataset.mvrId;
        wrap.appendChild(help.cloneNode(true));
        helpSlot.appendChild(wrap);
        paintVotes(helpSlot);
      }
      if (!modal.open) {
        modal.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    }

    function step(dir) {
      const cards = visibleCards();
      if (!current || cards.length < 2) return;
      const i = cards.indexOf(current);
      open(cards[(i + dir + cards.length) % cards.length]);
    }

    root.addEventListener('click', (event) => {
      const voteBtn = event.target.closest('[data-mvr-vote]');
      if (voteBtn) { event.preventDefault(); vote(voteBtn); return; }

      const more = event.target.closest('[data-mvr-more]');
      if (more) {
        const hidden = [...root.querySelectorAll('[data-mvr-card].is-hidden')];
        const n = parseInt(more.dataset.step, 10) || 6;
        hidden.slice(0, n).forEach((c) => c.classList.remove('is-hidden'));
        if (hidden.length <= n) more.closest('.mvr__more')?.remove();
        return;
      }

      if (event.target.closest('[data-mvr-close]')) { modal.close(); return; }
      if (event.target.closest('[data-mvr-prev]')) { step(-1); return; }
      if (event.target.closest('[data-mvr-next]')) { step(1); return; }
      if (event.target === modal) { modal.close(); return; }

      // Abre a avaliação ao clicar no card (menos em links e botões de voto)
      const card = event.target.closest('[data-mvr-card]');
      if (card && !event.target.closest('a')) open(card);
    });

    modal?.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      slot.innerHTML = '';
      current = null;
    });
    modal?.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
  }

  const boot = () => document.querySelectorAll('[data-mvr]').forEach(initReviews);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
